import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-carthrottle',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Car Throttle icon</title><path d="M0 19.99h5.31l1-5.76h2.673L7.97 19.99h5.272l1.037-5.76h2.824l-1 5.76h7.584L21.9 17.029 24 4.01h-5.16l-.987 5.647h-2.86l.936-5.647H8.483l1.724 2.749-.487 2.898H6.996l.9-5.647H.35l1.76 2.774Z"/></svg>`,
    styles: []
})
export class SimpleIconsCarthrottleComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF9C42';
    @Input() className: string = 'simple-icons-carthrottle'
    constructor() {}
    ngOnInit(): void {}
}
